<template>
    <ValidationProvider name="passenger_type" rules="required" v-slot="{ passed, failed }">
        <div class="line-container">
            <div class="line-box square" style="margin-top: 4px;">{{ form.seat_number }}</div>
            <div class="line-box" style="width: 130px;">
                <el-select v-model="form.passenger_type" placeholder="Select" filterable
                    class="form-group bold-text-blue super-bold" :class="[
                        { 'has-danger': failed },
                        { 'has-success': passed }]">
                    <el-option :value="i" :label="p" v-for="p, i in $store.state.passenger_types" :key="i">{{ p
                        }} </el-option>
                </el-select><br>
                <span class="error-text" v-if="failed">Passenger type is required</span>
            </div>
            <div class="line-box" style="width: 100px;padding-top: 12px;font-weight: bolder;">{{ money(form.total_fare) }}</div>
            <div class="line-box"><el-button type="danger" @click="handleRemove"><i class="fa fa-trash"></i></el-button></div>
        </div>
    </ValidationProvider>
</template>

<script>
import {
    extend
} from "vee-validate";
import {
    required
} from "vee-validate/dist/rules";

extend("required", required);

export default {
    props: ['ticket', 'booking'],
    data() {
        return {
            form: {
                seat_number: null,
                passenger_type: null
            }
        };
    },
    watch: {
        ticket: function () {
            this.init()
        },
        'form.passenger_type': function(){
            this.form.total_fare = this.getFare()
            this.$emit('update', this.form)
        },
        'form.total_fare': function(){
            this.$emit('update', this.form)
        }
    },
    created: function () {
        this.init()
    },
    methods: {
        init() {
            this.form = Object.assign({}, this.ticket)
            this.form.total_fare = this.getFare()
        },
        getFare() {
            let self = this
            let amount = 0
            this.booking.prices.forEach(price => {
                if (price.accommodation_id == self.form.accommodation_id && price.passenger_type == self.form.passenger_type) {
                    amount = price.total_fare
                }
            })

            return amount
        },
        handleRemove() {
            this.$emit('remove', this.form)
        }
    }
}
</script>

<style scoped>

</style>
